import { render, staticRenderFns } from "./biu-page.vue?vue&type=template&id=334f95a4&"
import script from "./biu-page.vue?vue&type=script&lang=tsx&"
export * from "./biu-page.vue?vue&type=script&lang=tsx&"
import style0 from "./biu-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports